import React from "react";
import Pagination from "../../Pagination";
import "./AdminHotelsTable.css"
export default function AdminHotelTable({ onDelete, hotelData, onEdit}) {
//   const styles = `
//   //   .hotel-grid {
//   //   display: grid;
//   //   grid-template-columns: repeat(4, 1fr);
//   //   gap: 20px;
//   // }

//   // .hotel-card {
//   //   position: relative;
//   //   border: 1px solid #ccc;
//   //   border-radius: 8px;
//   //   overflow: hidden;
//   //   height: 400px; 
//   // }

//   // .image-container {
//   //   position: relative;
//   //   width: 100%;
//   //   height: 100%;
//   // }

//   // .hotel-image {
//   //   position: absolute;
//   //   top: 0;
//   //   left: 0;
//   //   width: 100%;
//   //   height: 100%;
//   //   object-fit: cover; 
//   // }

//   // .edit-button, .delete-button {
//   //   position: absolute;
//   //   padding: 5px 10px;
//   //   border: none;
//   //   border-radius: 5px;
//   //   cursor: pointer;
//   //   z-index: 1;
//   // }

//   // .edit-button {
//   //   top: 10px;
//   //   right: 10px;
//   //   background-color: blue;
//   //   color: white;
//   // }

//   // .delete-button {
//   //   top: 10px;
//   //   left: 10px;
//   //   background-color: red;
//   //   color: white;
//   // }

//   // .data-overlay {
//   //   position: absolute;
//   //   bottom: 10px;
//   //   left: 50%;
//   //   transform: translateX(-50%);
//   //   color: white;
//   //   text-align: center;
//   //   text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
//   //   background-color: rgba(0, 0, 0, 0.5);
//   //   padding: 10px;
//   //   width: calc(100% - 20px);
//   //   box-sizing: border-box;
//   // }

//   // @media (max-width: 1200px) {
//   //   .hotel-grid {
//   //     grid-template-columns: repeat(4, 1fr);
//   //   }
//   // }

//   // @media (max-width: 900px) {
//   //   .hotel-grid {
//   //     grid-template-columns: repeat(3, 1fr);
//   //   }
//   // }

//   // @media (max-width: 600px) {
//   //   .hotel-grid {
//   //     grid-template-columns: repeat(2, 1fr);
//   //   }
//   // }

//   // @media (max-width: 400px) {
//   //   .hotel-grid {
//   //     grid-template-columns: repeat(1, 1fr);
//   //   }
//   // }

// `;

//   const styleSheet = document.createElement("style");
//   styleSheet.type = "text/css";
//   styleSheet.innerText = styles;
//   document.head.appendChild(styleSheet);
  return (
    <div className="max-w-full min-w-fit">
      {hotelData.length>0?
    <div className="hotel-grid mt-6 mb-6">
      {hotelData.map((hotel,index) => (
        <div key={index} className="hotel-card space-x-2">
          <div className="hotel-container">
            <img
              src={hotel.image_url}
              alt={hotel.name}
              className="hotel-image"              
              onError={(e) => e.target.style.display = 'none'}
            />
            <div className="data-overlay" key={index} >
              <p className="text-white italic">{hotel.name}</p>
              <p className="text-white italic">{hotel.email}</p>
              <h4 className="text-white italic">{hotel.location}</h4>
              <p className="text-white italic">{hotel.goods_type}</p>
            </div>
            <button className="edit-button " onClick={() => onEdit(hotel)}>EDIT</button>
            <button className="delete-button" onClick={() => onDelete(hotel)}>DELETE</button>
          </div>
        </div>
      ))}
    </div>
    :<p>Sorry, no there are no hotels</p>}
    {/* <Pagination postsPerPage={postsPerPage} totalPosts={length} currentPage={currentPage} paginate={hanldeChange}/> */}
    </div>
  );
}

